import { render, staticRenderFns } from "./POAData.vue?vue&type=template&id=a475eb3c&scoped=true"
import script from "./POAData.vue?vue&type=script&lang=js"
export * from "./POAData.vue?vue&type=script&lang=js"
import style0 from "./POAData.vue?vue&type=style&index=0&id=a475eb3c&prod&scoped=true&lang=css"
import style1 from "./POAData.vue?vue&type=style&index=1&id=a475eb3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a475eb3c",
  null
  
)

export default component.exports